import { makeStyles } from '@material-ui/styles';
import { Theme, Text } from '@bizzabo/design-system';
import ChatMessageDialog from '../CustomMessage/ChatMessageDialog';
import ChatMessageDialogTitle from './components/ChatMessageDialogTitle';
import ChatMessageDialogDescription from './components/ChatMessageDialogDescription';
import ChatMessageDialogOneButtonFooter from './components/ChatMessageDialogOneButtonFooter';

const BanUserOneTimeDialogMessage = ({ sessionChatContainer, event, onClick }) => {
    const classes = useStyles();
    const orgEmail = event.supportEmail;
    const mailTo = 'mailTo:' + orgEmail;
    return (
        <ChatMessageDialog parentElementRef={sessionChatContainer} onClose={onClick}>
            <ChatMessageDialogTitle>
                We’re sorry but you can no longer communicate here
            </ChatMessageDialogTitle>
            <ChatMessageDialogDescription>
                <Text variant="t81" className={classes.text}>
                    The admin has blocked you due to suspicion of inappropriate content. For more
                    information:{' '}
                    <a className={classes.mailTo} href={mailTo}>
                        {orgEmail}
                    </a>
                </Text>
            </ChatMessageDialogDescription>
            <ChatMessageDialogOneButtonFooter buttonText="Okay, I understand" onClick={onClick} />
        </ChatMessageDialog>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        text: {
            color: theme.palette.greys['700'],
        },
        mailTo: {
            color: 'rgb(47, 134, 215)',
        },
    }),
    {
        classNamePrefix: 'BanUserOneTimeDialogMessage',
    }
);

export default BanUserOneTimeDialogMessage;
